var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newGroupPeople" } }, [
    _c(
      "div",
      {
        staticClass: "people-item",
        on: {
          click: function (e) {
            return _vm.onSelect(e)
          },
        },
      },
      [
        _c("span", { staticClass: "people-info" }, [
          _c(
            "span",
            { staticClass: "user-segment-avatar text-center" },
            [
              _c(
                "md-highlight-text",
                { staticClass: "text-center", attrs: { "md-term": "term" } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s((_vm.row.name || "").slice(0, 1).toUpperCase()) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(" " + _vm._s(_vm.row.name) + " ")]),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "select-people" },
          [
            _c("a-checkbox", {
              staticClass: "segment-checkbox",
              attrs: { checked: _vm.selected },
              on: {
                click: function (e) {
                  return _vm.onSelect(e)
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "line" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }